<template>
    <div class="analytic-tab" v-if="isMounted">
        <div class="analytic-tab__tabs">
            <div
                v-for="(tab, index) of tabs"
                :key="index"
                class="analytic-tab__tab"
                :class="{active: activeTab === tab.event}"
                @click="changeTab(tab)"
            >{{ $t(tab.name) }}</div>
        </div>

        <div class="analytic-tab__content">
            <transition name="zoom-fade" mode="out-in">
                <component :is="activeTab"></component>
            </transition>
        </div>
    </div>
</template>

<script>
import history from '@/mixins/history'
export default {
    mixins: [history],

    data() {
        return {
            isMounted: false,
            activeTab: null,
            tabs: [
                {name: 'sideMenu.Leads', event: 'Leads'},
                {name: 'sideMenu.Analytics', event: 'Analytics'}
            ]
        }
    },

    components: {
        Leads: () => import("@/views/analytics/Leads.vue"),
        Analytics: () => import("@/views/analytics/Analytics.vue")
    },

    methods: {
        changeTab(tab) {
            this.$router.push({query: {tab: tab.event}})

            this.activeTab = tab.event
        }
    },

    mounted() {
        const history = this.getHistory()

        if (history.tab) {
            this.activeTab = history.tab
        } else {
            this.activeTab = this.tabs[0].event
        }

        this.isMounted = true
    }
}
</script>

<style lang="scss">
@mixin active {
    text-decoration: underline;
    color: rgba(var(--vs-primary), 1);
}

.analytic-tab {
    &__tabs {
        display: flex;
        align-items: center;
        margin-bottom: 25px;
    }

    &__tab {
        margin-right: 15px;
        cursor: pointer;

        &.active {
            @include active
        }

        &:hover {
            @include active
        }
    }

    .tabs {
        &__tab {
            padding: {
                right: 10px;
                left: 10px;
            }
            position: relative;
            cursor: pointer;

            &.active,
            &:hover {
                text-decoration: underline;
            }

            &.disabled {
                pointer-events: none;
                color: #9d9d9d;
            }

            &:first-child {
                padding: {
                    left: 0;
                }
            }

            &:last-child {
                &:after {
                    display: none;
                }
            }

            &:after {
                content: '';
                display: block;
                position: absolute;
                top: 3px;
                bottom: 3px;
                right: 0;
                width: 1px;
                background-color: #626262;
                border-radius: 50px;
            }
        }
    }

    .input__filter {
        width: 100%;
    }
}
</style>
